import { apiClient } from './client';

export type EventType = 'sorteo' | 'quiz' | 'raspa' | 'ruleta' | 'rojo_negro' | 'slot';
export type EventStatus = 'draft' | 'active' | 'paused' | 'ended' | 'cancelled';

export interface Event {
  id: string;
  tenantId: string;
  type: EventType;
  name: string;
  description: string | null;
  flyerUrl: string | null;
  depositMin: string | null;
  prizeKind: string | null;
  prizeAmount: string | null;
  prizeDescription: string | null;
  durationMin: number | null;
  status: EventStatus;
  config: Record<string, unknown> | null;
  startsAt: string | null;
  endsAt: string | null;
  createdAt: string;
}

export interface CreateEventBody {
  type: EventType;
  name: string;
  description?: string;
  flyerUrl?: string;
  depositMin?: string;
  prizeKind?: string;
  prizeAmount?: string;
  prizeDescription?: string;
  durationMin?: number;
  status?: EventStatus;
  config?: Record<string, unknown>;
  startsAt?: string;
  endsAt?: string;
}

export interface UpdateEventBody {
  type?: EventType;
  name?: string;
  description?: string;
  flyerUrl?: string;
  depositMin?: string;
  prizeKind?: string;
  prizeAmount?: string;
  prizeDescription?: string;
  durationMin?: number;
  status?: EventStatus;
  config?: Record<string, unknown>;
  startsAt?: string;
  endsAt?: string;
}

export const eventsApi = {
  list: async (): Promise<Event[]> => {
    const { data } = await apiClient.get('/admin/events');
    return data as Event[];
  },

  get: async (id: string): Promise<Event> => {
    const { data } = await apiClient.get(`/admin/events/${id}`);
    return data as Event;
  },

  create: async (body: CreateEventBody): Promise<Event> => {
    const { data } = await apiClient.post('/admin/events', body);
    return data as Event;
  },

  update: async (id: string, body: UpdateEventBody): Promise<Event> => {
    const { data } = await apiClient.patch(`/admin/events/${id}`, body);
    return data as Event;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/events/${id}`);
  },

  start: async (id: string): Promise<Event> => {
    const { data } = await apiClient.post(`/admin/events/${id}/start`);
    return data as Event;
  },

  end: async (id: string): Promise<Event> => {
    const { data } = await apiClient.post(`/admin/events/${id}/end`);
    return data as Event;
  },

  draw: async (id: string): Promise<Event> => {
    const { data } = await apiClient.post(`/admin/events/${id}/draw`);
    return data as Event;
  },
};
